(() => {
  const root = document.querySelector('[data-anya-wacart]');
  if (!root || window.AnyaCart) return;
  const W = JSON.parse(document.querySelector('[data-anya-runtime]')?.textContent || '{}');
  const L = JSON.parse(root.querySelector('[data-wacart-labels]')?.textContent || '{}');
  const key = 'anya_wacart_v1';
  const currency = root.dataset.currency || 'DH';
  const flatShipping = Number(root.dataset.shippingPrice || 0);
  const freeShippingAmount = Number(root.dataset.freeShippingAmount || 0);
  const list = root.querySelector('[data-wacart-items]');
  const empty = root.querySelector('[data-wacart-empty]');
  const checkout = root.querySelector('[data-wacart-checkout]');
  const cityInput = root.querySelector('[data-wacart-city]');
  const promoInput = root.querySelector('[data-wacart-promo]');
  const status = root.querySelector('[data-wacart-status]');
  const el = (name) => root.querySelector(`[data-wacart-${name}]`);
  let shippingRate = null;
  let lastFocus = null;

  // Panier gardé sur l'appareil du client pendant sa navigation (commande finale envoyée sur WhatsApp).
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } };
  const write = (items) => { try { localStorage.setItem(key, JSON.stringify(items)); } catch (e) {} };
  let items = read();

  const money = (value) => `${Number(value).toLocaleString('fr-FR')} ${currency}`;
  const fill = (template, values) => String(template || '').replace(/\{(\w+)\}/g, (match, name) => (name in values ? values[name] : match));
  const round = (value) => Math.round(value * 100) / 100;
  const totals = () => {
    const products = round(items.reduce((sum, item) => sum + Number(item.price || 0), 0));
    const reference = round(items.reduce((sum, item) => sum + Math.max(Number(item.reference || 0), Number(item.price || 0)), 0));
    const welcome = window.AnyaWelcome?.calculate(products) || { discount: 0, net: products };
    let fee = null;
    if (shippingRate) fee = freeShippingAmount > 0 && Math.round(products * 100) >= Math.round(freeShippingAmount * 100) ? 0 : (flatShipping > 0 ? flatShipping : shippingRate.price);
    return { products, savings: round(Math.max(0, reference - products)), welcome, fee, total: fee === null ? null : round(welcome.net + fee) };
  };

  const render = () => {
    list.replaceChildren();
    items.forEach((item) => {
      const row = document.createElement('li');
      row.className = 'anya-wacart__item';
      const name = document.createElement('strong');
      name.textContent = `${item.product} — ${item.offer}`;
      const price = document.createElement('b');
      price.textContent = money(item.price);
      const detail = document.createElement('span');
      detail.textContent = (item.lines || []).join(' · ');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = L.remove;
      remove.addEventListener('click', () => { items = items.filter((entry) => entry.id !== item.id); write(items); render(); });
      row.append(name, price, ...(item.lines?.length ? [detail] : []), remove);
      list.append(row);
    });
    empty.hidden = items.length > 0;
    checkout.hidden = items.length === 0;
    const sum = totals();
    el('products').textContent = money(sum.products);
    [el('savings-label'), el('savings')].forEach((node) => { node.hidden = sum.savings <= 0; });
    el('savings').textContent = `− ${money(sum.savings)}`;
    [el('welcome-label'), el('welcome')].forEach((node) => { node.hidden = sum.welcome.discount <= 0; });
    el('welcome').textContent = `− ${money(sum.welcome.discount)}`;
    el('shipping').textContent = sum.fee === null ? L.shipping_pending : (sum.fee === 0 ? L.shipping_free : money(sum.fee));
    el('total').textContent = sum.total === null ? L.shipping_pending : money(sum.total);
    el('delay').textContent = shippingRate ? `${L.shipping_delay_label} : ${window.AnyaShippingRates.readableDelay(shippingRate.delay)}` : '';
    const count = items.length ? String(items.length) : '';
    document.querySelectorAll('[data-wacart-count]').forEach((badge) => { badge.textContent = count; });
  };

  const open = () => {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.anya-wacart__close')?.focus();
  };
  const close = () => {
    root.hidden = true;
    document.documentElement.style.overflow = '';
    lastFocus?.focus?.();
  };

  root.querySelectorAll('[data-wacart-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !root.hidden) close(); });
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wacart-open]');
    if (toggle) { event.preventDefault(); open(); }
  });
  window.addEventListener('storage', (event) => { if (event.key === key) { items = read(); render(); } });

  window.AnyaShippingRates?.attach(cityInput, (match) => {
    shippingRate = match;
    if (match) { cityInput.value = match.city; cityInput.removeAttribute('aria-invalid'); status.textContent = ''; }
    render();
  }, currency, {
    priceText: flatShipping > 0 ? fill(L.shipping_rule, { price: money(flatShipping), amount: money(freeShippingAmount) }) : '',
    rate: L.shipping_rate_label,
    delay: L.shipping_delay_label,
    hint: L.city_search_hint,
    empty: L.city_no_results,
  });

  root.querySelector('[data-wacart-order]').addEventListener('click', () => {
    const phone = String(root.dataset.whatsappNumber || '').replace(/\D/g, '');
    if (!phone) { status.textContent = L.no_phone; return; }
    const delivery = window.AnyaShippingRates?.lookup(cityInput.value || '');
    if (!delivery) {
      cityInput.setAttribute('aria-invalid', 'true');
      status.textContent = L.city_required;
      cityInput.focus();
      return;
    }
    shippingRate = delivery;
    const sum = totals();
    const promo = String(promoInput?.value || '').trim();
    const message = [
      W.greeting,
      '',
      W.intent,
      ...items.flatMap((item, index) => [`${index + 1}. ${item.product} — ${item.offer} : ${money(item.price)}`, ...(item.lines || []).map((line) => `   • ${line}`)]),
      `${W.city} : ${delivery.city}`,
      '',
      `${W.products} : ${money(sum.products)}`,
      ...(sum.savings > 0 ? [`${L.economy} : ${money(sum.savings)}`] : []),
      ...(window.AnyaWelcome?.lines(sum.products, currency) || []),
      `${W.shipping} : ${sum.fee === 0 ? L.shipping_free : money(sum.fee)}`,
      `${window.AnyaWelcome?.totalLabel || L.total} : ${money(sum.total)}`,
      ...(promo ? [`${L.promo_message_label} : ${promo}`, L.promo_message_note] : []),
      '',
      W.confirm,
    ].join('\n');
    status.textContent = '';
    window.Shopify?.analytics?.publish?.('anya_whatsapp_order', {
      source: 'cart',
      items: items.map((item) => ({ product: item.handle, offer_name: item.offer, choices: item.lines, value: item.price })),
      city: delivery.city,
      products_value: sum.products,
      discount: sum.welcome.discount,
      shipping: sum.fee,
      value: sum.total,
      currency: window.Shopify?.currency?.active || 'MAD',
      promo_code: promo,
      language: document.documentElement.lang,
      page: window.location.pathname,
    });
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  });

  window.AnyaCart = {
    // item : { product, handle, offer, lines: [], price, reference, url }
    add(item) {
      items.push({ ...item, id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` });
      write(items);
      render();
      open();
    },
    items: () => items.slice(),
    open,
    labels: L,
  };
  render();
})();
